<template>
  <div>
    <div class="flex space-x-1 not-prose mt-4" role="tablist">
      <div
        v-for="(item, index) in items"
        :key="'tab_' + index"
      >
        <button
          @click="setActive('tab_' + index)"
          @keyup.enter="setActive('tab_' + index)"
          class="inline-flex flex-shrink pb-4 pt-5 px-5 lg:px-8 h-full rounded-t-lg items-center antialiased leading-none text-lg text-white mr-1 font-bold"
          :class="{
            'bg-accent text-primary-dark': active == 'tab_' + index,
            'bg-primary': active != 'tab_' + index,
          }" >
          {{ item.tab_title }}
        </button>
      </div>
    </div>
    <div
      class="py-8 px-6 md:px-12 bg-white dark:bg-accent border-2 border-accent md:rounded-tr-lg rounded-b-lg mb-6"
    >
      <div
        role="tabpanel"
        tabindex="0"
      >
        <div
          v-for="(item, index) in items"
          :key="'content_panel_' + index"
        >
          <div
            class="prose md:prose-lg dark:prose-invert max-w-full"
            :class="{ 'hidden': active != 'tab_' + index }"
            v-html="item.tab_content"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      active: 'tab_0'
    }
  },
  methods: {
    setActive (name) {
      if(this.active == name){
        this.active = ''
      }else{
        this.active = name
      }

    }
  }
}
</script>
